import { APPLICATION_ROUTES } from "../routes";

/** Routes that bring their own header. Decided by the route so the app's header never paints while the page loads. */
const ROUTES_WITHOUT_APP_MENU: string[] = [APPLICATION_ROUTES.WELCOME];

export const isAppMenuShown = (appMenuVisible: boolean, pathname: string): boolean =>
	appMenuVisible && !ROUTES_WITHOUT_APP_MENU.includes(pathname);
